<!--转单产品-->
<template>
  <Page class="queryView">
    <template v-slot:contentTop>
      <div class="queryView-conditions with-btn-end">
        <a-form layout="inline" :form="form">
          <a-form-item label="产品名称" porps="productName">
            <a-input v-decorator="['productName']" placeholder="请输入企业名称"></a-input>
          </a-form-item>
          <a-form-item label="国家" porps="countryName">
            <a-input v-decorator="['countryName']" placeholder="请输入国家名称"></a-input>
          </a-form-item>
          <a-form-item label="供应商名称" porps="supplierName">
            <a-input v-decorator="['supplierName']" placeholder="请输入供应商"></a-input>
          </a-form-item>
          <a-form-item label="状态" porps="supplierName">
            <a-select v-decorator="['status']" style="width: 140px" placeholder="请输入供应商">
              <a-select-option value="1">已上线</a-select-option>
              <a-select-option value="20">供应商下线</a-select-option>
              <a-select-option value="21">运营端下线</a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
        <div class="condition-btns">
          <a-button class="app-btn" type="default" @click="resetAndQuery">重置搜索</a-button>
          <a-button class="app-btn" type="primary" @click="handleSearch">立即搜索</a-button>
        </div>
      </div>
    </template>
    <div>
      <div class="pageContent-title">产品列表</div>
      <div class="queryView-main">
        <a-table
          class="mt-5"
          :rowKey="record => record.productId"
          bordered
          :loading="tableLoading"
          :columns="tableColumns"
          :dataSource="dataSource"
          @change="handleTableChange$qv"
          :pagination="{
            current: pageNumber,
            pageSize: pageSize,
            total: countTotal,
            showSizeChanger: true,
            showQuickJumper: true,
          }"
        ></a-table>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '6%',
        align: 'center',
        // dataIndex: 'userName',
        customRender: (text, row, index) => {
          return <div>{this.pageSize * (this.pageNumber - 1) + index + 1}</div>
        },
      },
      {
        title: '产品名称',
        align: 'center',
        dataIndex: 'productName',
      },
      {
        title: '供应商',
        align: 'center',
        dataIndex: 'supplierName',
      },
      {
        title: '国家',
        width: '100px',
        align: 'center',
        dataIndex: 'countryName',
      },
      {
        title: '领区',
        width: '200px',
        align: 'center',
        dataIndex: 'consularRegionName',
      },

      {
        title: '状态',
        width: '120px',
        align: 'center',
        dataIndex: 'productStatus',
        customRender: text => {
          // 1-上线，20-供应商下线，21-运营端下线
          return <div>{text === 1 ? '已上线' : text === 20 ? '供应商下线' : text === 20 ? '运营端下线' : '-'}</div>
        },
      },
      {
        title: '操作',
        width: '15%',
        align: 'center',
        dataIndex: 'detail',
        customRender: (text, row, index) => {
          return (
            <div class="flex gap-4 justify-center items-center text-primary-500">
              <span
                style="cursor:pointer"
                onClick={() => {
                  this.editRow(row)
                }}
              >
                查看
              </span>
              <span
                style="cursor:pointer"
                onClick={() => {
                  this.checkLink(row)
                }}
              >
                复制小程序地址
              </span>
              <span
                style="cursor:pointer"
                onClick={() => {
                  this.changeOnShelf(row)
                }}
              >
                {row.isOnShelf === 0 ? '上架' : '下架'}
              </span>
            </div>
          )
        },
      },
    ]
    return {
      form: this.$form.createForm(this),
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      tableLoading: false,
      tableColumns: tableColumns,
      modal: {
        visible: false,
        title: '',
        data: {},
      },
      dataSource: [],
      auditUserId: null,
      auditUserIdList: [],
    }
  },
  components: {
    Page,
  },
  computed: {
    typesMap() {
      return {}
    },
  },
  async mounted() {
    if (this.$route.query.pageNumber) {
      this.pageNumber = parseInt(this.$route.query.pageNumber)
    }
    if (this.$route.query.countryName || this.$route.query.productName || this.$route.query.supplierName) {
      const obj = {
        countryName: this.$route.query.countryName,
        productName: this.$route.query.productName,
        supplierName: this.$route.query.supplierName,
      }
      this.safeSetFieldsValue$t(this.form, { ...obj })
    }
    this.doQuery()
  },
  methods: {
    handleSearch() {
      this.doQuery(1)
    },
    getParams() {
      const params = this.form.getFieldsValue()
      return {
        ...params,
      }
    },
    async doQuery(_pageNumber = this.pageNumber, _pageSize = this.pageSize) {

      this.tableLoading = true
      try {
        const res = await this.$axios.get('/visa/admin/product', {
          params: {
            page: _pageNumber,
            limit: _pageSize,
            ...this.getParams(),
          },
        })
        // const { number, total, content } = res.data
        this.countTotal = Number(res.count)
        // this.pageNumber = number
        // this.dataSource = content
        this.dataSource = res.data
      } catch (e) {
        console.log(e)
      }
      this.tableLoading = false
    },

    resetAndQuery() {
      this.resetAndQuery$qv()
    },

    async changeOnShelf(row) {
      const resData = await this.$axios.post('/visa/admin/productMaterial/queryMaterialListByProductId', {
        data: {
          productId: row.productId,
        },
      })
      if (resData.data && resData.data.length > 0) {
        await this.$axios.post('/visa/admin/productTransfer/setProductOnShelf', {
          data: {
            productId: row.productId,
            isOnShelf: row.isOnShelf === 0 ? 1 : 0,
          },
        })
        this.$message.success('操作成功')
        this.doQuery()
      } else {
        this.$message.error('请配置产品资料')
      }
    },
    addRow() {
      this.$router.push({
        path: '/m/scopeMain/transferProduct/addProducts',
        query: {
          pageNumber: this.pageNumber,
          channelId: this.form.getFieldValue('channelId'),
          productName: this.form.getFieldValue('productName'),
          countryId: this.form.getFieldValue('countryId'),
        },
      })
    },
    editRow(row) {
      this.$router.push({
        path: '/m/scopeMain/transferProduct/addProducts',
        query: {
          productId: row.productId,
          pageNumber: this.pageNumber,
          channelId: this.form.getFieldValue('channelId'),
          productName: this.form.getFieldValue('productName'),
          countryId: this.form.getFieldValue('countryId'),
        },
      })
    },
    async checkLink(row) {
      const text = `/pages/product/index?productId=${row.productId}`
      try {
        await navigator.clipboard.writeText(text)
        this.$message.success('复制成功')
      } catch (err) {
        // 降级方案
        this.copyTextFallback(text)
      }
    },

    copyTextFallback(text) {
      // 使用方法1的实现
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
        this.$message.success('复制成功')
      } catch (err) {
        this.$message.error('复制失败')
      }
      document.body.removeChild(textarea)
    },
  },
}
</script>

<style lang="less"></style>
